export enum ModbusFunctionCode {
  ReadCoils = 0x01,
  ReadDiscreteInputs = 0x02,
  ReadHoldingRegisters = 0x03,
  ReadInputRegisters = 0x04,
  WriteSingleCoil = 0x05,
  WriteSingleRegister = 0x06,
  WriteMultipleCoils = 0x0F,
  WriteMultipleRegisters = 0x10,
}

export enum ModbusExceptionCode {
  IllegalFunction = 0x01,
  IllegalDataAddress = 0x02,
  IllegalDataValue = 0x03,
  ServerDeviceFailure = 0x04,
  Acknowledge = 0x05,
  ServerDeviceBusy = 0x06,
}

export type ModbusDataArea = 'COIL' | 'DISCRETE_INPUT' | 'INPUT_REGISTER' | 'HOLDING_REGISTER';

export interface ModbusMapping {
  area: ModbusDataArea;
  modbusAddress: number; // 0-65535
  plcAddress: string; // e.g. "Q0.0", "M10.0", "IW4", "MW20"
}

export interface ModbusRequest {
  id: string; // Unique request ID
  unitId: number;
  functionCode: ModbusFunctionCode;
  startAddress: number;
  quantity?: number;
  values?: number[]; // Values to write
  timestamp: number;
}

export interface ModbusResponse {
  requestId: string;
  unitId: number;
  functionCode: ModbusFunctionCode;
  isException: boolean;
  exceptionCode?: ModbusExceptionCode;
  data?: number[]; // Read data
  timestamp: number;
}
